import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FormularioEditable } from '../postulacion-formulario.models';

@Component({
  selector: 'app-postulacion-paso-informacion-general',
  imports: [CommonModule, FormsModule],
  templateUrl: './postulacion-paso-informacion-general.html',
  styleUrl: './postulacion-formulario-paso.shared.css',
})
export class PostulacionPasoInformacionGeneral {
  @Input({ required: true }) formulario!: FormularioEditable;
  @Input() soloLectura = false;
  @Input() mostrarSeccionProyecto = true;
  @Output() changed = new EventEmitter<void>();

  readonly opcionesDuracionProyecto = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  registrarCambio(): void {
    this.changed.emit();
  }
}
